function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Cloud 2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M64.5833 66.6667H136.806C146.01 66.6667 153.472 59.2047 153.472 50C153.472 40.7953 146.01 33.3333 136.806 33.3333C135.707 33.3333 134.633 33.4397 133.593 33.6426C133.876 32.6625 134.028 31.6267 134.028 30.5556C134.028 24.4191 129.053 19.4444 122.917 19.4444C119.586 19.4444 116.597 20.9101 114.561 23.2316C114.576 22.897 114.583 22.5605 114.583 22.2222C114.583 9.94923 104.634 0 92.3611 0C80.0881 0 70.1389 9.94923 70.1389 22.2222C70.1389 22.4574 70.1425 22.6917 70.1498 22.9251C68.3708 22.4663 66.5056 22.2222 64.5833 22.2222C52.3103 22.2222 42.3611 32.1714 42.3611 44.4444C42.3611 56.7174 52.3103 66.6667 64.5833 66.6667Z",
  fill: "#D6EBFF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Cloud 1",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M111.111 85.112L111.123 85.112H172.222C178.359 85.112 183.333 80.1374 183.333 74.0009C183.333 67.8644 178.359 62.8898 172.222 62.8898H167.958C168.903 61.2555 169.445 59.358 169.445 57.3342C169.445 51.1977 164.47 46.2231 158.333 46.2231C157.165 46.2231 156.039 46.4034 154.981 46.7376C152.698 36.8931 143.873 29.5564 133.333 29.5564C121.06 29.5564 111.111 39.5057 111.111 51.7786C101.907 51.7787 94.4446 59.2406 94.4446 68.4453C94.4446 77.6501 101.907 85.112 111.111 85.112Z",
  fill: "#99CEFF"
}), /*#__PURE__*/React.createElement("path", {
  id: "Cloud 3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.6667 93.4444H16.6667H13.8889V93.214C6.00635 91.8916 0 85.0361 0 76.7778C0 67.573 7.46192 60.1111 16.6667 60.1111C18.8347 60.1111 20.9061 60.5251 22.806 61.2783C24.7322 54.2026 31.203 49 38.8889 49C46.3585 49 52.6803 53.9138 54.7984 60.6852C55.9088 60.3129 57.0975 60.1111 58.3333 60.1111C64.4698 60.1111 69.4444 65.0857 69.4444 71.2222C69.4444 71.3389 69.4426 71.4551 69.4391 71.5709C74.2341 72.8025 77.7778 77.1541 77.7778 82.3333C77.7778 88.4698 72.8032 93.4444 66.6667 93.4444Z",
  fill: "#C2E1FF"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "noun-power-off-7532903 1",
  transform: "translate(60, 20)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 11",
  cx: 31.5,
  cy: 32.5,
  r: 26.5,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 3.20001C47.9051 3.20001 60.8 16.0949 60.8 32C60.8 47.9051 47.9051 60.8 32 60.8C16.0949 60.8 3.20001 47.9051 3.20001 32C3.20001 16.0949 16.0949 3.20001 32 3.20001ZM33.92 28.2048V19.8848C33.92 17.3573 30.08 17.3573 30.08 19.8848V28.2048C30.08 30.7323 33.92 30.7323 33.92 28.2048ZM37.6225 25.8348C43.1948 30.9198 39.63 40.3399 32.0001 40.3399C24.3623 40.3399 20.8103 30.91 26.3777 25.8375C28.2427 24.1375 25.6627 21.305 23.7977 23.0025C15.6452 30.4297 20.8602 44.1801 31.9999 44.1801C43.1395 44.1801 48.3551 30.4302 40.202 23.0025C38.337 21.3025 35.7545 24.1375 37.622 25.8349L37.6225 25.8348ZM49.6503 14.35C39.9031 4.60279 24.0977 4.60279 14.3505 14.35C4.60332 24.0972 4.60332 39.9025 14.3505 49.6497C24.0977 59.3969 39.9031 59.3969 49.6503 49.6497C59.3975 39.9025 59.3975 24.0972 49.6503 14.35Z",
  fill: "#0067C5"
}));

function SvgDeprecatedService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 94,
    viewBox: "0 0 184 94",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedService);
export default __webpack_public_path__ + "static/media/Deprecated_service.5cb81a28dfd4364180a1f486963cc9f5.svg";
export { ForwardRef as ReactComponent };